<template>
    <div v-if="product" class="event relative pointer m-2" @click="showDetails" @mouseenter="showBook" @mouseleave="hideBook">
        <transition name="fade">
            <button v-if="button" class="btn book lines" @click="book($event, event)">BOOK</button>
        </transition>

        <div class="information bg-lightest darker border-light py-2 px-3">
            <!-- <div :class="['bg-' + product.color, 'mt-1', 'mr-1', 'circle']"></div> -->

            <div class="d-inline-block bold">
                <p>{{ event.start | moment('HH:mm') }} to {{ event.end | moment('HH:mm') }}</p>

                <p>{{ product.name }}</p>

                <p v-if="product.transport" class="dark">{{ product.transport.name }}</p>
            </div>

            <event-meter :event="event" :showText="true"></event-meter>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import { mapGetters, mapActions } from 'vuex'
    import EventMeter from './EventMeter'

    export default {
        props: {
            event: Object
        },
        data: function () {
            return {
                button: false,
            }
        },
        computed: {
            ...mapGetters([
                'getClonedReservation',
            ]),
            product: function() {
                return this.event.product;
            }
        },
        methods: {
            ...mapActions([
                'resetClonedReservation',
                'updateClonedReservation',
                'updateSelectedEvent',
                'initEventNotes',
                'setReservationSelectedEvent',
                'setReservationSelectedProduct',
            ]),
            book: function() {
                // this.resetClonedReservation().then(() => {
                //     let clone = JSON.parse(JSON.stringify(this.getClonedReservation));
                //     clone.event = this.event;
                //
                //     this.updateClonedReservation(clone);
                //
                //     this.$router.push({ name: 'pluralo.reservation.new' });
                // });
                // this.$router.push('/reservation')

                this.setReservationSelectedEvent(this.event);
                this.setReservationSelectedProduct(this.event.product);
                this.$router.push('/reservation/resume');
            },
            showBook: function() {
                this.button = true;
            },
            hideBook: function() {
                this.button = false;
            },
            showDetails: function() {
                // Launch event notes

                this.initEventNotes(this.event.id);

                // Set the currently clicked event

                this.updateSelectedEvent(this.event.id);

                // Animate side panels

                $('.events .list').addClass('moved-left');
                $('.events .more').removeClass('moved-right');
            }
        },
        components: {
            EventMeter
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';

    .calendar .event .book {
        position: absolute;
        top: 0.75rem;
        right: 0.75rem;
        z-index: 1;
    }
</style>



// WEBPACK FOOTER //
// Event.vue?f349768e